import React, { useState } from 'react';
import PropTypes from 'prop-types';

import enhanceWithServices from 'hocs/enhanceWithServices';
import Modal from 'components/Modal';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import ProjectSelector from './ProjectSelector';
import CoursewareSelector from './CoursewareSelector';
import LockPluginVersionModal from './LockPluginVersionModal';

import messages from './messages';

const STEPS = Object.freeze({
  project: 'project',
  courseware: 'courseware',
  version: 'version',
});

function DeployCohortCoursewareModal({
  cohortId,
  deploy,
  onDismiss,
  onPublishActivity,
  projectService,
  visible,
}) {
  const [step, setStep] = useState(STEPS.project);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(null);

  const handleDismiss = () => {
    onDismiss();
    setStep(STEPS.project);
  };

  const onNextProject = (projectId) => {
    setStep(STEPS.courseware);
    setSelectedProjectId(projectId);
  };

  const onNextCourseware = (activity) => {
    setStep(STEPS.version);
    setSelectedActivity(activity);
  };

  const onDeploy = (checkboxValues) => {
    const { lockPluginVersion, supportOnDemandEnabled, scorable, forceUpdateAssessments, addToLibrary } = checkboxValues;

    deploy(selectedActivity.activityId, cohortId, lockPluginVersion, supportOnDemandEnabled, scorable, forceUpdateAssessments, addToLibrary);
    onPublishActivity(selectedActivity, cohortId);
    handleDismiss();
  };

  let component = null;

  if (step === STEPS.project) {
    component = (<ProjectSelector
      onDismiss={handleDismiss}
      onNext={onNextProject}
      projectService={projectService}
    />);
  } else if (step === STEPS.courseware) {
    component = (<CoursewareSelector
      projectId={selectedProjectId}
      onDismiss={handleDismiss}
      onNext={onNextCourseware}
      projectService={projectService}
    />);
  } else if (step === STEPS.version) {
    component = (<LockPluginVersionModal
      onDismiss={handleDismiss}
      onDeploy={onDeploy}
      cohortId={cohortId}
      activityId={selectedActivity?.activityId}
    />);
  }

  let title = '';

  if (step === STEPS.project) {
    title = intl.formatMessage(messages.selectProject);
  } else if (step === STEPS.courseware) {
    title = intl.formatMessage(messages.selectCourseware);
  } else if (step === STEPS.version) {
    title = intl.formatMessage(messages.lockPluginVersionTitle);
  }

  return (
    <Modal
      visible={visible}
      onDismiss={handleDismiss}
      title={title}
    >
      {component}
    </Modal>
  );
}

DeployCohortCoursewareModal.propTypes = {
  cohortId: PropTypes.string,
  deploy: PropTypes.func,
  onDismiss: PropTypes.func,
  onPublishActivity: PropTypes.func,
  projectService: PropTypes.object,
  visible: PropTypes.bool,
};

export default enhanceWithServices(DeployCohortCoursewareModal);
